import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface GuideViewProps {
  images: string[];
  onBack: () => void;
}

const GuideView: React.FC<GuideViewProps> = ({ images, onBack }) => {
  return (
    <div className="p-4 min-h-[80vh] animate-fade-in">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={onBack} className="p-2 bg-white dark:bg-slate-800 rounded-full shadow-sm">
          <ArrowLeft size={20} className="text-gray-600 dark:text-gray-300" />
        </button>
        <h2 className="text-xl font-bold text-gray-800 dark:text-white font-myanmar">ငွေတွက်နည်း လမ်းညွှန်</h2>
      </div>

      {images.length === 0 ? (
        <div className="text-center py-20 bg-white dark:bg-slate-800 rounded-2xl border border-dashed border-gray-200 dark:border-slate-700">
          <p className="text-gray-400 font-myanmar">လမ်းညွှန်ပုံများ မရှိသေးပါ။</p>
        </div>
      ) : (
        <div className="space-y-6">
          {images.map((img, index) => (
            <div key={index} className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden">
               <div className="p-3 border-b border-gray-50 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-900/50">
                  <span className="text-xs font-bold text-blue-600 dark:text-blue-400">Step {index + 1}</span>
               </div>
               <img 
                 src={img} 
                 alt={`Guide Step ${index + 1}`} 
                 className="w-full h-auto object-contain max-h-[500px]"
                 loading="lazy"
               />
            </div>
          ))}
        </div>
      )}
      
      <div className="h-20" /> {/* Spacer */}
    </div>
  );
};

export default GuideView;